import './about_us_component.scss'
